<kb-progress-indicator
  [visible]="true"
></kb-progress-indicator>
